import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { earlyExitWorkout } from '../workout.api';
import { useAppToasts } from '@/hooks/use-app-toasts';
import { QueryKey } from '@/api/common/types/query-key.enum';

export const useEarlyExitWorkout = (workoutEventId: string | undefined) => {
  const queryClient = useQueryClient();
  const { raiseErrorToast } = useAppToasts();
  const { mutateAsync, isPending } = useMutation({
    mutationKey: [QueryKey.EarlyExitWorkout, workoutEventId],
    mutationFn: earlyExitWorkout,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [QueryKey.GetWorkouts] });
      await queryClient.invalidateQueries({ queryKey: [QueryKey.GetRecoverableWorkout] });
      await queryClient.invalidateQueries({ queryKey: [QueryKey.GetLoggedInUser] });
      if (workoutEventId) {
        await queryClient.invalidateQueries({ queryKey: [QueryKey.GetWorkout, workoutEventId] });
      }
    },
    onError: () => {
      raiseErrorToast();
    },
  });
  return {
    earlyExitWorkout: mutateAsync,
    loading: isPending,
  };
};
